import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// import slide_image_1 from '../pages/image1/IMG-20240928-WA0023.jpg';
// import slide_image_2 from '../pages/image1/IMG-20240928-WA0022.jpg';
// import slide_image_3 from '../pages/image1/IMG-20240928-WA0023.jpg';
// import slide_image_4 from '../pages/image1/IMG-20240928-WA0018.jpg';
// import slide_image_5 from '../pages/image1/jin3.jpg';
// import slide_image_6 from '../pages/image1/IMG-20240919-WA0021.jpg';
// import slide_image_7 from '../pages/image1/jin5.jpg';

// const imageArray = [
//     slide_image_1,
//     slide_image_2,
//     slide_image_3,
//     slide_image_4,
//     slide_image_5,
//     slide_image_6,
//     slide_image_7
// ];
function Swipernew({ images }) {

    return (
        
        <div className="container w-75 h-50 ">
            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                loop={true}
                slidesPerView={'auto'}
                coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 100,
                    modifier: 2.5,
                }}
                pagination={{ el: '.swiper-pagination', clickable: true }}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    clickable: true,
                }}
                modules={[EffectCoverflow, Pagination, Navigation]}
                className="swiper_container"
            >
                {images.map((image, index) => (
                    <SwiperSlide key={index}>
                        <div className='w-100 d-flex align-items-center justify-content-center'>
                            <div className="card">
                                <img
                                    src={image}
                                    className="card-img img-fluid"
                                    alt={`slide-${index}`}
                                    style={{ height: '50vh', objectFit: 'cover' }}
                                />
                            </div>
                        </div>
                    </SwiperSlide>
                ))}

                <div className="slider-controler">
                    <div className="swiper-button-prev slider-arrow text-white">
                        <ion-icon name="arrow-back-outline"></ion-icon>
                    </div>
                    <div className="swiper-button-next slider-arrow text-white">
                        <ion-icon name="arrow-forward-outline"></ion-icon>
                    </div>
                    <div className='pt-5'>
                        <div className="swiper-pagination"></div>  
                    </div>
                </div>
            </Swiper>
           
        </div>
    );
}

export default Swipernew;
